import _ from 'underscore';
import rivets from 'rivets';

rivets.formatters.log = function (value) {
    console.log('Logging in formatter');
    console.log(value);

    return value;
};

rivets.formatters.length = function (value) {
    return value.length;
};

rivets.formatters.objToArray = function (obj) {
    return _.values(obj);
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/rivets/formatters.js
 **/